const config = {
    athomApiClientId: "67a0c698b7b3beed26a927f0",
    athomApiClientSecret: "3e6dfe7ce87f002ae90e91f8ead9c79ce96891e2",
    googleMapsApiKey: "AIzaSyByDOHIR_VAurMSVoW8ENyZ3DtPglSThig",
};

export default config;